import { render } from "./TaskCardReading.vue?vue&type=template&id=8a39150c&scoped=true"
import script from "./TaskCardReading.vue?vue&type=script&lang=js"
export * from "./TaskCardReading.vue?vue&type=script&lang=js"

import "./TaskCardReading.vue?vue&type=style&index=0&id=8a39150c&scoped=true&lang=css"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a39150c"]])

export default __exports__